const NEW_TICKET_REPORT_ALLOWED_EMAILS = [
  "j.pedwa@travelport-cnwa.com.qa",
  "j.pedwa@travelport-cnwa.com",
];

export const canAccessNewTicketReport = (email = "") =>
  NEW_TICKET_REPORT_ALLOWED_EMAILS.includes(email.trim().toLowerCase());

export const canAccessMultiPccTicketReport = (email = "") =>
  NEW_TICKET_REPORT_ALLOWED_EMAILS.includes(email.trim().toLowerCase());
